import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import axios from 'axios';
import baseURL from './baseURL/BaseURL';

const ResetPasswordScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const reset_password_token = queryParams.get('reset_password_token'); // Extract token from URL

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const validateForm = () => {
    const errors = {};
    if (!password) {
      errors.password = 'Password is required';
    } else if (password.length < 6) {
      errors.password = 'Password must be at least 6 characters';
    }

    if (!confirmPassword) {
      errors.confirmPassword = 'Confirm password is required';
    } else if (password !== confirmPassword) {
      errors.confirmPassword = 'Passwords do not match';
    }

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    setMessage('');
    setLoading(true);

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setLoading(false);
      return;
    }

    try {
      const response = await baseURL.patch(`/users/password`, {user:{
        reset_password_token, 
          password,
      }
      });

      if (response.status === 200) {
        setMessage('Password updated successfully! Redirecting...');
        setTimeout(() => navigate('/login'), 3000);
      }
    } catch (error) {

      setErrors(error.message);
    }
    setLoading(false);
  };

  return (
    <div className="flex h-screen">
      <div className="w-1/2 max-md:w-full flex flex-col justify-center items-center bg-white px-8">
        <div className="w-full max-w-md">
          <h2 className="text-3xl font-bold text-center mb-2">Reset Password</h2>
          <p className="text-center text-gray-500 mb-6">Enter a new password for your account.</p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-gray-600 mb-1">New Password</label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter new password"
                  className={`w-full px-4 py-2 border ${errors.password ? 'border-[#730000]' : 'border-gray-300'} rounded-md`}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <span
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-700 cursor-pointer"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEye /> : <FaEyeSlash />}
                </span>
              </div>
              {errors.password && <p className="text-[#730000] text-sm mt-1">{errors.password}</p>}
            </div>

            <div>
              <label className="block text-gray-600 mb-1">Confirm Password</label>
              <input
                type="password"
                placeholder="Confirm new password"
                className={`w-full px-4 py-2 border ${errors.confirmPassword ? 'border-[#730000]' : 'border-gray-300'} rounded-md`}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              {errors.confirmPassword && <p className="text-[#730000] text-sm mt-1">{errors.confirmPassword}</p>}
            </div>

            {errors.apiError && <p className="text-[#730000] text-sm mt-1">{errors.apiError}</p>}
            {message && <p className="text-green-600 text-sm mt-1">{message}</p>}

            <button
              type="submit"
              className="w-full bg-[#730000] text-white py-2 rounded-md font-semibold"
              disabled={loading}
            >
              {loading ? "Updating..." : "Update Password"}
            </button>
          </form>
        </div>
      </div>
      <div className="w-1/2 max-md:hidden relative flex items-center justify-center">
        <img
          src="https://plus.unsplash.com/premium_vector-1721219771657-0b6c64520575?q=80&w=2960&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
          alt="Illustration"
          className="z-10 w-80"
        />
      </div>
    </div>
  );
};

export default ResetPasswordScreen;
